/**
 * @generated SignedSource<<93c61007d384d80943f053a6eafa2f02>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type HeaderLogo_company$data = {
  readonly logo: {
    readonly url: string | null | undefined;
  } | null | undefined;
  readonly nameFriendly: string | null | undefined;
  readonly " $fragmentType": "HeaderLogo_company";
};
export type HeaderLogo_company$key = {
  readonly " $data"?: HeaderLogo_company$data;
  readonly " $fragmentSpreads": FragmentRefs<"HeaderLogo_company">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "HeaderLogo_company",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "nameFriendly",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "File",
      "kind": "LinkedField",
      "name": "logo",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "fitIn",
              "value": true
            }
          ],
          "kind": "ScalarField",
          "name": "url",
          "storageKey": "url(fitIn:true)"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Company",
  "abstractKey": null
};

(node as any).hash = "154176487d3abeed1438634245981dc5";

export default node;
